import { render, staticRenderFns } from "./BrandsList.vue?vue&type=template&id=739ff712&scoped=true"
import script from "./BrandsList.vue?vue&type=script&lang=js"
export * from "./BrandsList.vue?vue&type=script&lang=js"
import style0 from "./BrandsList.vue?vue&type=style&index=0&id=739ff712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739ff712",
  null
  
)

export default component.exports